// Helper function to get nested value using dot notation
export function getNestedValue(obj: any, path: string): any {
	// If path doesn't contain a dot, return the direct property
	if (!path.includes(".")) {
		return obj?.[path];
	}

	// Handle nested path
	const keys = path.split(".");
	let current = obj;
	for (const key of keys) {
		if (current == null) return undefined;
		current = current[key];
	}
	return current;
}

// Helper function to set nested value using dot notation
export function setNestedValue(obj: any, path: string, value: any): any {
	// If path doesn't contain a dot, set the direct property
	if (!path.includes(".")) {
		return { ...obj, [path]: value };
	}

	// Handle nested path
	const keys = path.split(".");
	if (keys.length === 1) {
		return { ...obj, [path]: value };
	}

	const [firstKey, ...restKeys] = keys;
	const restPath = restKeys.join(".");
	const nestedObj = obj[firstKey] || {};

	return {
		...obj,
		[firstKey]: setNestedValue(nestedObj, restPath, value),
	};
}
